import React from "react";

import styles from "./Eyebrow.module.css";

const Eyebrow = ({ children, color }) => (
	<span className={`${styles.eyebrow} ${styles[`color${color}`]}`}>{children}</span>
);

export default Eyebrow;